module.exports = __webpack_public_path__ + "img/image_25.07aafb80.png";